import { LangObject } from "@brg/api/dist/api-core/utils/lang-utils";
import React, { BaseSyntheticEvent, FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { ITeamFilterModel, TeamFilterEditView } from "./TeamFilterEditView";
//import { PageViewportLayout } from "shared/components/template";
import { ProjectEditPageGrid, ProjectEditPageGridRow } from "shared/pages/projectEdit/styles";
import { ProjectEditPageGridInput } from "_deziiign/books/pages/BookEdit/styles";
import { Input } from "@brg/input";
import { API, Designer, Endpoints, Lang, UploadFileAPI } from "@brg/api";
import { useTranslation } from "react-i18next";
import { CommonInput, CommonLabel, FlexBox, INPUT_TYPES, repeat, useBreakpoint, useIsMobile, useToasts } from "@brg/ui";
import { MagicBoxRow } from "shared/pages/project/components/toolsStyles";
import { LayoutConst, useModal } from "core";
import { allowedCharacters, buttonTypes, buttonTypesForModer, ITeamButton, ShowCaseTitleType, validateUrlString } from "../TeamEdit";
import { LangBlockWrapper, TeamEditLabel, UploaderWrapper, DefaultButton, MobileButtonsWrapper, GridMobileNamed, TeamsMobGridList, ActionsButton, TBody } from "../styles";
import { LangTitleBox } from "shared/components/LangTitleBox/LangTitleBox";
import { TabType } from "./TeamTabsBlock";
import { createEmptyLangObject } from "../../../components/__ADDONS__/__SAFEAPI__/Empty";
import ProjectAuthorsEdit, { ProjectAuthorsChangeCbT } from "shared/pages/projectEdit/ProjectAuthorsEdit";
import { useDesignerById } from "shared/hooks/api/useDesignerById";
import { useDesignerList } from "shared/hooks/api/useDesignersByProjects";
import { useDesignersAll } from "shared/hooks";
//@ts-ignore
import Switch from 'react-input-switch';
import TeamTopLinksBlock, { ITeamTopLink } from "./TeamTopLinksBlock";
import { useSimpleUploader } from '@brg/uploader';
import { TeamUploadContainer } from "../components/TeamUploadContainer";
import { CoverWrapper, TableSortWrapper } from "../styles";
import EditIcon24 from "shared/icons/EditIcon24";
import DeleteIcon from "shared/icons/DeleteIcon";
import { ProjectEditPageGridList } from "_deziiign/books/pages/BookEdit/styles";
import { JustTable, RequiredLabel, RequiredSpan } from "_competition/components/style";
import { SpecialDropdownButtons } from "./SpecialDropdownButtons";
import { InfoIcon } from "shared/components/InfoIcon/InfoIcon";
import PlusSvg from "shared/assets/32/PlusSvg";

const DESCRIPTION_MAX_LENGTH = 1000;

const setTextByLang = (
  current: LangObject[],
  lang: string,
  value: string
): LangObject[] => {
  const engValue = current.find(({ lang }) => lang === 'en') ?? {
    lang: 'en',
    name: '',
  };
  const ruValue = current.find(({ lang }) => lang === 'ru') ?? {
    lang: 'ru',
    name: '',
  };

  if (lang === 'ru') {
    return [{
      lang: 'ru',
      name: value,
    }, engValue];
  } else {
    return [ruValue, {
      lang: 'en',
      name: value,
    }];
  }
}

export interface ITeamTab {
  titleImages?: any;
  titleImageContainerId?: string;
  path: string;
  name: LangObject[];
  about: LangObject[];
  filter: ITeamFilterModel;
  isMain: boolean;
  currentLang?: string;
  entityType?: string;
  rolesList?: string[];
  designerIds?: string[];
  href?: string;
  isOpenInNewTab: boolean;
  category?: string;
  gridTitle: LangObject[];
  gridTitleLink: LangObject[];
  topLinks?: ITeamTopLink[]; 
  isLinksShow?: boolean; 
  coverLink?: { path: string; newTab: boolean };
  buttons?: any[];
}

type TeamTabEditPropsT = {
  type?: TabType,
  isModer?: boolean,
  categories?: ITeamTab[],
  tab: ITeamTab,
  onChange?: (tab: ITeamTab) => void;
  teamId?: string;
  team?: any;
  anchorTypes?: any;
  actualForms?: any;
  tabIndex?: number;
  maxLGButtonsCount?: number;
  updateTeam: () => void;
  setIsChangesSaved?: (saved: boolean) => void;
}

export const TeamTabEdit: FC<TeamTabEditPropsT> = (props) => {
  const { t, i18n } = useTranslation();
  const is1280 = useBreakpoint(LayoutConst.screen.l_12);
  const toasts = useToasts();
  const isMobile = useIsMobile();
  const isS = useBreakpoint(LayoutConst.screen.s);
  const modal = useModal();

  const { tab, onChange, type, categories, isModer, teamId, tabIndex, updateTeam, team, anchorTypes, actualForms, maxLGButtonsCount=0, setIsChangesSaved } = props;

  const [currentTab, setCurrentTab] = useState<ITeamTab>(tab);
  const [designers, setDesigners] = useState<Designer[]>([]);

  // Обновляем currentTab когда изменяется tab
  useEffect(() => {
    setCurrentTab(tab);
  }, [tab]);

  const [showCaseTitleType, setShowCaseTitleType] = useState(ShowCaseTitleType.text);
  const [isLinksInsteadTitle, setIsLinksInsteadTitle] = useState(
    currentTab.isLinksShow ?? false
  );
  const [topLinks, setTopLinks] = useState<ITeamTopLink[]>(currentTab.topLinks || []);
  const [tabButtons, setTabButtons] = useState(currentTab.buttons || []);
  const [isDeletingButton, setIsDeletingButton] = useState(false);
  const titleRef = useRef<any>();
  const MAX_TOP_LINKS_COUNT = 5;
  const fileInputRef = useRef<HTMLInputElement>(null);
  const sipRef = useRef<any>(null);
  const hasTeamTabBG = useMemo(() => !!currentTab?.titleImages?.length, [currentTab, team]);
  const onTabChange = useCallback((changedTab: ITeamTab) => {
    setCurrentTab(changedTab);
    onChange?.(changedTab);
  }, [onChange]);

  const onSetTopLinks = useCallback((val: any) => {
    if (val?.length > MAX_TOP_LINKS_COUNT && val) {
        toasts.error(`Максимальное количество заглавных ссылок: ${MAX_TOP_LINKS_COUNT}`);
        return;
    }
    setTopLinks(val)
    onTabChange({ ...currentTab, topLinks: val });
}, [currentTab, onTabChange])
  
  const onTitleVisibleChange = useCallback(() => {
    if (showCaseTitleType) {
        setShowCaseTitleType(ShowCaseTitleType.text);
        setIsLinksInsteadTitle(false);
    } else {
        setShowCaseTitleType(ShowCaseTitleType.link);
        setIsLinksInsteadTitle(true);
        if (topLinks?.length === 0) {
          setTopLinks([{
              name: createEmptyLangObject('', ['ru', 'en']),
              link: ''
          }]);
      }
    }
    
    onTabChange({ ...currentTab, isLinksShow: !isLinksInsteadTitle});
}, [showCaseTitleType, topLinks]);



  const onDesignersChange = ({ authors }: ProjectAuthorsChangeCbT) => {
    onTabChange({ 
      ...currentTab, 
      filter: {
        ...currentTab.filter, 
        designerIds: authors?.map(({ designerId }) => designerId) 
      } 
    })
  }

  useEffect(() => {
    if (!!tab?.filter?.designerIds?.length) {
      API.request()
      .endpoint(Endpoints.geograffee)
      .url('api/Designer/GetList')
      .addQuery('designerIds', tab?.filter?.designerIds)
      .get()
      .send()
      .then((r) => r.json())
      .then((r) => setDesigners(API.toLang(r.data, i18n.language)))
    } else {
      setDesigners([])
    }
  } , [tab, i18n])

  const onLocalLangChange = (arr: any[], lang: string, callback: (test: any[]) => void) => callback(arr?.map((i: any) => ({
    ...i,
    currentLang: lang === 'ru' ? 'en' : 'ru'
  })));

  const categoryList = useMemo(() => {
    if (type === TabType.tab && categories) {
      return categories.map(({ path }) => ({
        label: path,
        value: path
      }))
    }
    return []
  }, [type, categories]);

  const entityList = useMemo(() => {
    return [{
      label: t('teams.adminPage.entities.projects'),
      value: 'projects'
    }, {
      label: t('teams.adminPage.entities.cached_projects'),
      value: 'main'
    }, {
      label: t('teams.adminPage.entities.teams'),
      value: 'organizations',
    }, {
        label: t('teams.adminPage.entities.competitions'),
        value: 'competitions_new',
    }, {
      label: t('teams.adminPage.entities.modules'),
      value: 'modules',
    }, {
      label: t('teams.adminPage.entities.people'),
      value: 'people',
    }, {
      label: t('teams.adminPage.entities.people_in_detail'),
      value: 'people_in_detail',
    }
  ]
  }, [t])

  const currentRoles = useMemo(() => {
    //@ts-ignore
    return currentTab?.filter?.rolesList?.reduce((acc, val) => [...acc, { label: val, value: val }], []) || []
  }, [currentTab])

  const rolesOptions = useMemo(() => {
    //@ts-ignore
    return [
      { label: 'expertmoder', value: 'expertmoder'},
      { label: 'dafessovet', value: 'dafessovet'}
    ]
  }, [])


  useEffect(() => {
    setTabButtons(currentTab.buttons || []);
  }, [currentTab.buttons]);

  const onTabButtonChange = (button: ITeamButton, idx: number) => {
    const newButtons = tabButtons.map((b, i) => (i === idx ? button : b));
    setTabButtons(newButtons);
    onTabChange({ ...currentTab, buttons: newButtons });
  };
  const onTabButtonAdd = () => {
    const newButtons = [
      ...tabButtons,
      {
            type: 'filled',
            text: createEmptyLangObject('', ['ru', 'en']),
            textMobile: createEmptyLangObject('', ['ru', 'en']),
            href: createEmptyLangObject('', ['ru', 'en']),
            isRequired: false,
            actionType: '',
            anchor: { label: '', value: '' },
        },
    ];
    setTabButtons(newButtons);
    onTabChange({ ...currentTab, buttons: newButtons });
  };
  const onTabButtonDelete = (idx: number) => {
    setIsDeletingButton(true);
    const newButtons = tabButtons.filter((_, i) => i !== idx);
    setTabButtons(newButtons);
    onTabChange({ ...currentTab, buttons: newButtons });
    setIsChangesSaved?.(true);
    setTimeout(() => {
      setIsDeletingButton(false);
    }, 500);
  };
  const onTabButtonLangChange = (lang: string) => {
    const newButtons = tabButtons.map((b) => ({ ...b, currentLang: lang }));
    setTabButtons(newButtons);
    onTabChange({ ...currentTab, buttons: newButtons });
  };

  const buttonsBlock = useMemo(() => {
    const currentLang = tabButtons?.find((button) => button?.currentLang)?.currentLang || 'ru';
    return (
      <LangBlockWrapper offsetTop={40} offsetTopMobile={isS ? 24 : 40} direction={is1280 ? 'column' : 'row'} directionMobile={isMobile ? 'column' : 'row'}>
        <CommonLabel
          label={t('teams.adminPage.fields.page_buttons')}
          onLanguageChange={() => onTabButtonLangChange(currentLang === 'ru' ? 'en' : 'ru')}
          lang={currentLang}
          useLangSwitcher={!!tabButtons?.length}
          fixedHeight
          onWhiteBG
        />
        <ProjectEditPageGridRow directionMobile={!!tabButtons?.length ? 'column' : 'row'} isTeamEdit>
          <ProjectEditPageGridList direction={'column'} directionMobile="column" isTeamEdit>
            {!tabButtons?.length && (
              <FlexBox direction={'row'} directionMobile="row" style={{ marginBottom: !tabButtons?.length ? 0 : 24 }}>
                <DefaultButton wh={195} whMob={195} onClick={onTabButtonAdd}>
                  {/* <PlusSvg /> */}
                  {t('teams.adminPage.buttons.create')}
                </DefaultButton>
              </FlexBox>
            )}
            {(!!tabButtons?.length) && (
                                        <>
                                        {isMobile ? (
                                            <>
                                                {tabButtons.map((button, index) => {
                                                    return (
                                                        <MobileButtonsWrapper directionMobile="row" gxMobile={24} offsetTopMobile={24} >
                                                            {isS && (
                                                                <GridMobileNamed>
                                                                    <span>{`Кнопка ${index + 1}`}</span>
                                                                    {button.isRequired ? (
                                                                         <FlexBox justify={'flex-start'} width={'100px'}>
                                                                        </FlexBox>
                                                                    ) : (
                                                                         <DefaultButton wh={131} whMob={107} onClick={() => onTabButtonDelete(index)} isTablet disabled={isDeletingButton}>Удалить</DefaultButton>
                                                                    )}
                                                                </GridMobileNamed>
                                                            )}
                                                            <TeamsMobGridList isTeamEditButtons cols={repeat(2, isMobile ? '260px' : '306.5px')} >
                                                                <CommonInput 
                                                                    type={INPUT_TYPES.dropdown}
                                                                    orientation="column"
                                                                    label={t('teams.adminPage.additionalFields.td_style')}
                                                                    value={{ label: button.type, value: button.type }}
                                                                    onChange={(value: any) => onTabButtonChange({ ...button, type: value.value }, index)}
                                                                    options={isModer ? buttonTypesForModer : buttonTypes}
                                                                />
                                                                <CommonInput 
                                                                    type={INPUT_TYPES.text}
                                                                    orientation="column"
                                                                    label={t('teams.adminPage.additionalFields.td_text')}
                                                                    value={Lang(button.text, currentLang)}
                                                                    onChange={(value: any) => onTabButtonChange({ ...button, text: setTextByLang(button.text, currentLang, value.target.value)}, index)}
                                                                />
                                                                <CommonInput 
                                                                    type={INPUT_TYPES.text}
                                                                    orientation="column"
                                                                    label={t('teams.adminPage.additionalFields.td_text_mobile')}
                                                                    value={Lang(button.textMobile, currentLang)}
                                                                    onChange={(value: any) => onTabButtonChange({ ...button, textMobile: setTextByLang(button.textMobile, currentLang, value.target.value)}, index)}
                                                                />
            
                                                                <FlexBox  directionMobile="column">
                                                                    <CommonLabel 
                                                                        label={t('teams.adminPage.additionalFields.td_href')}
                                                                        fixedHeight
                                                                        onWhiteBG
                                                                    />
                                                                    <ProjectEditPageGridInput isTeamEdit isColumns>
                                                                        {button.type?.includes('anchor') ? (
                                                                            <CommonInput 
                                                                                type={INPUT_TYPES.dropdown}
                                                                                orientation="column"
                                                                                value={{ label: button.type, value: button.type }}
                                                                                onChange={(value: any) => onTabButtonChange({ ...button, type: value.value }, index)}
                                                                                options={isModer ? buttonTypesForModer : buttonTypes}
                                                                            />
                                                                        ) : (
                                                                            <>
                                                                                {!!button?.isRequired ? (
                                                                                    <ActionsButton>{t(`teams.adminPage.additionalFields.button_${button.actionType}`)}</ActionsButton>
                                                                                ) : (
                                                                                    <SpecialDropdownButtons
                                                                                        currentLang={currentLang}
                                                                                        button={button}
                                                                                        index={index} 
                                                                                        onChange={onTabButtonChange}
                                                                                        actualForms={actualForms}
                                                                                    />
                                                                                )}
                                                                            </>
                                                                        )}
            
                                                                        </ProjectEditPageGridInput>
                                                                    </FlexBox>
                                                                </TeamsMobGridList>
                                                                {!isS && (
                                                                    <>
                                                                        {!!button?.isRequired ? (
                                                                            <FlexBox justify={'flex-start'} style={{ height: '88px' }}>
                                                                            </FlexBox>
                                                                        ) : (
                                                                            <DefaultButton style={{ marginTop: isMobile ? '26px' : 0 }} wh={131} whMob={107} onClick={() => onTabButtonDelete(index)} disabled={isDeletingButton}>{t('teams.adminPage.buttons.delete')}</DefaultButton>
                                                                        )}
            
                                                                    </>
                                                                )}
                                                            </MobileButtonsWrapper>
                                                        )
                                                    })}
                                                </>
                                        ) : (
                                            <JustTable isTeamEdit>
                                                <thead>
                                                    <tr>
                                                        <RequiredLabel style={{width: '20%'}} className={'required-label'}>{t('teams.adminPage.additionalFields.td_style')}</RequiredLabel>
                                                        <RequiredLabel style={{width: '25%'}} className={'required-label'}>{t('teams.adminPage.additionalFields.td_text')}</RequiredLabel>
                                                        <th style={{width: '25%'}}>{t('teams.adminPage.additionalFields.td_text_mob')}</th>
                                                        <th style={{width: '25%'}}>
                                                            <FlexBox align="center" gx={4}>
                                                                <RequiredSpan className={'required-label'}>{t('teams.adminPage.additionalFields.td_href')}</RequiredSpan> 
                                                                <InfoIcon stc msg={t('teams.adminPage.additionalFields.team_context_link')} />
                                                            </FlexBox>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <TBody>
                                                    {tabButtons.map((button, index) => {
                                                        return (
                                                            <tr>
                                                                <td style={{width: '195px'}}>
                                                                    <CommonInput 
                                                                        type={INPUT_TYPES.dropdown}
                                                                        value={{ label: t(`teams.adminPage.additionalFields.${button.type}`), value: button.type }}
                                                                        onChange={(value: any) => onTabButtonChange({ ...button, type: value.value }, index)}
                                                                         options={(isModer ? buttonTypesForModer : buttonTypes).map(option => ({
                                                                            label: t(`teams.adminPage.additionalFields.${option.label}`),
                                                                            value: option.value
                                                                        }))}
                                                                    />
                                                                </td>
                                                                <td style={{width: '180px'}}>
                                                                    <CommonInput 
                                                                        type={INPUT_TYPES.text}
                                                                        value={Lang(button.text, currentLang)}
                                                                        onChange={(value: any) => onTabButtonChange({ ...button, text: setTextByLang(button.text, currentLang, value.target.value)}, index)}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <CommonInput 
                                                                        type={INPUT_TYPES.text}
                                                                        value={Lang(button.textMobile, currentLang)}
                                                                        onChange={(value: any) => onTabButtonChange({ ...button, textMobile: setTextByLang(button.textMobile, currentLang, value.target.value)}, index)}
                                                                    />
                                                                </td>
                                                                    <>
                                                                    <td>
                                                                        {button.type?.includes('anchor') ? (
                                                                            <>
                                                                                {!!anchorTypes?.length ? (
                                                                                    <CommonInput 
                                                                                        type={INPUT_TYPES.dropdown}
                                                                                        value={button.anchor}
                                                                                        onChange={(value: any) => onTabButtonChange({ ...button, anchor: value}, index)}
                                                                                        options={anchorTypes}
                                                                                    />
                                                                                ) : (
                                                                                    <ActionsButton>{t('teams.adminPage.additionalFields.anchor_not_exist')}</ActionsButton>
                                                                                )}
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                {!!button?.isRequired ? (
                                                                                    <ActionsButton>{t(`teams.adminPage.additionalFields.button_${button.actionType}`)}</ActionsButton>
                                                                                ) : (
                                                                                    <SpecialDropdownButtons
                                                                                        currentLang={currentLang}
                                                                                        button={button}
                                                                                        index={index} 
                                                                                        onChange={onTabButtonChange}
                                                                                        actualForms={actualForms}
                                                                                    />
                                                                                )}
                                                                            </>
                                                                        )}
                                                                    </td>
            
                                                                        <td>
                                                                            {!!button?.isRequired ? (
                                                                                <FlexBox justify={'flex-start'}>
            
                                                                                </FlexBox>
                                                                            ) : (
                                                                                <DefaultButton wh={131} whMob={107} onClick={() => onTabButtonDelete(index)} disabled={isDeletingButton}>{t('teams.adminPage.buttons.delete')}</DefaultButton>
                                                                            )}
                                                                        </td>
                                                                    </>
                                                                </tr>
                                                            );
                                                        })}
                                                    </TBody>
                                                </JustTable>
                                            )}
                                        </>
                                    )}
            {!!tabButtons?.length && tabButtons?.length < maxLGButtonsCount && (
              <FlexBox direction={'row'} directionMobile="row" style={{ marginTop: 16 }}>
                <DefaultButton wh={195} whMob={195} onClick={onTabButtonAdd}>
                  <PlusSvg />
                  {t('teams.adminPage.buttons.add')}
                </DefaultButton>
              </FlexBox>
            )}
          </ProjectEditPageGridList>
        </ProjectEditPageGridRow>
      </LangBlockWrapper>
    );
  }, [tabButtons, isS, t, is1280, isMobile, maxLGButtonsCount]);


  const nameBlock = useMemo(() => {
    return (
      <LangBlockWrapper offsetTop={40} offsetTopMobile={isS ? 24 : 40} direction="row"
                        directionMobile={isS ? 'column' : 'row'}>

        <CommonInput 
          type={INPUT_TYPES.text}
          label={t('teams.adminPage.fields.name')}
          orientation="wide"
          useLangSwitcher
          value={currentTab.name}
          maxLength={100}
          onChange={(ev: any, lang?: string) => {
            onTabChange(
              { ...currentTab, name: setTextByLang(currentTab.name, lang ?? 'ru', ev.target.value) })
          }
          }

        />
      </LangBlockWrapper>
    )
  }, [currentTab, isMobile, isS])

  const aboutBlock = useMemo(() => {
    return (
      <LangBlockWrapper offsetTop={40} offsetTopMobile={isS ? 24 : 40} direction="row"
                        directionMobile={isS ? 'column' : 'row'}>
        <CommonInput 
          maxLength={DESCRIPTION_MAX_LENGTH}
          type={INPUT_TYPES.textarea}
          label={t('teams.adminPage.fields.tab_description')}
          useLangSwitcher
          value={currentTab.about}
          onChange={(value: any, lang?: string) => onTabChange({
            ...currentTab,
            about: setTextByLang(currentTab.about, lang ?? 'ru', value.target.value)
          })}
        />
      </LangBlockWrapper>
    )
  }, [currentTab, isMobile, isS])

  const gridTitleBlock = useMemo(() => {
    return (
      <LangBlockWrapper offsetTop={40} offsetTopMobile={isS ? 24 : 40} direction="row"
                        directionMobile={isS ? 'column' : 'row'}>
        <CommonInput 
          type={INPUT_TYPES.text}
          label={t('teams.adminPage.fields.grid_title')}
          useLangSwitcher
          value={currentTab.gridTitle || createEmptyLangObject('', ['ru', 'en'])}
          onChange={(ev: any, lang?: string) => {
            onTabChange(
              { ...currentTab, gridTitle: setTextByLang((currentTab.gridTitle || createEmptyLangObject('', ['ru', 'en'])), lang ?? 'ru', ev.target.value) })
          }
          }
        />
      </LangBlockWrapper>
    )
  }, [currentTab, isMobile, isS])

  const gridTitleLinkBlock = useMemo(() => {
    return (
      <LangBlockWrapper offsetTop={40} offsetTopMobile={isS ? 24 : 40} direction="row"
                        directionMobile={isS ? 'column' : 'row'}>

        <CommonInput 
          type={INPUT_TYPES.text}
          label={t('teams.adminPage.fields.grid_title_link')}
          useLangSwitcher
          value={currentTab.gridTitleLink || createEmptyLangObject('', ['ru', 'en'])}
          onChange={(ev: any, lang?: string) => {
            onTabChange(
              { ...currentTab, gridTitleLink: setTextByLang((currentTab.gridTitleLink || createEmptyLangObject('', ['ru', 'en'])), lang ?? 'ru', ev.target.value) })
          }
          }
        />
      </LangBlockWrapper>
    )
  }, [currentTab, isMobile, isS])
  
  const titleTypeBlock = useMemo(() => {
    return (
        <ProjectEditPageGridRow align="flex-start" style={{marginTop: isS ? 24 : 40}} isTeamEdit switchValue={showCaseTitleType} >
            <CommonLabel 
              label={t('teams.adminPage.additionalFields.header_show')}
              fixedHeight
            />
            <FlexBox ref={titleRef} direction={isS ? "column" : "row"} justify="space-between" align={isS ? "start": "center"} width={isS ? '100%' : '600px'} style={{ maxWidth: '600px', flexDirection: isS ? "column" : "row"}}>
                        <FlexBox direction="row" directionMobile="row" gx={16} gxMobile={16} offsetBottomMobile={8}>
                            <span className={'input-span'}> {t('teams.adminPage.additionalFields.header_title_text')}</span>
                            <Switch className={'showcase-switcher'} value={showCaseTitleType} onChange={onTitleVisibleChange} />
                            <span className={'input-span'}> {t('teams.adminPage.additionalFields.header_title_link')}</span>
                        </FlexBox>
            </FlexBox>
        </ProjectEditPageGridRow>
    )
},[isS, showCaseTitleType, onTitleVisibleChange, t])

const topLinksBlock = useMemo(() => {
  return (
    <TeamTopLinksBlock
      isMobile={isMobile}
      isS={isS}
      is1280={is1280}
      topLinks={topLinks}
      setTopLinks={onSetTopLinks}
      onLocalLangChange={onLocalLangChange}
    />
  )
}, [topLinks, isMobile, isS, is1280, onSetTopLinks])


const uploaderCallback = useCallback(
  (fileId: string) => {
    if (!fileId || teamId === null || tabIndex === null) return null;
    return UploadFileAPI.Upload({
      fileId,
      profileId: teamId,
      service: 'geography',
      entityType: `geographyteamavatartab_${tabIndex}`,
      localization: i18n.language,
    }).then((res: any) => {
       sipRef.current.uploader.uploader.uppy.reset();
      updateTeam();
      if (res?.data?.titleImages) {
        onTabChange({ ...currentTab, titleImages: res.data.titleImages });
      }
      return res;
    });
  },
  [teamId, tabIndex, i18n.language, hasTeamTabBG, updateTeam, currentTab, onTabChange]
);

const uploadValidator = useCallback(async (files: any) => {
  let failedChecks: {
    dimensions?: boolean;
    size?: boolean;
    ratio?: boolean;
    type?: boolean;
  } = {};

  const loadFile = () => new Promise<{width: number, height: number}>((resolve, reject) => {
    const fr = new FileReader();
    fr.onload = function () {
      const img = new Image();
      img.onload = function () {
        const { width, height } = img;
        resolve({ width, height });
      };
      // @ts-ignore
      img.src = fr.result;
    };
    fr.readAsDataURL(files[0]);
  });

  // @ts-ignore
  const { height, width } = await loadFile();

  if (!['image/jpeg'].includes(files?.[0]?.type)) {
    toasts.error('Допустимые форматы: jpg');
    failedChecks.type = true;
  }

  const { size: failedSize, dimensions: failedDimensions, ratio: failedRatio, type: failedType } = failedChecks;

  if (failedSize || failedDimensions || failedRatio || failedType) {
     sipRef.current.uploader.inputRef.current.value = '';
    return false;
  }

  return true;
}, [toasts, fileInputRef, hasTeamTabBG]);
const sip = useSimpleUploader(uploaderCallback, uploadValidator);
 sipRef.current = sip;


const onDeleteTabBG = useCallback(() => {
  modal.show('confirmDeleteCoverModal', {
    teamId: teamId ?? '',
    teamBGLang: false,
    tabIndex: tabIndex,
    isTabImg: true,
    onDelete: updateTeam,
    handleClose: modal.hide,
    entityType: `geographyteamavatartab_${tabIndex}`,
  });
}, [teamId, currentTab?.titleImages, updateTeam, tabIndex, team]);

const teamBG = useMemo(() => {
  if (hasTeamTabBG) {
    return (
      <CoverWrapper justify="flex-start" direction="column" directionMobile="column" align={'flex-start'} alignMobile="flex-start">
        <FlexBox className={'cover-container'} direction={'row'} directionMobile="row" offsetTopMobile={10}>
          <span>{currentTab.titleImages?.[0]?.url?.split('/').slice(-1)}</span>
          {/* <FlexBox direction="row" directionMobile="row" offsetLeft={12} offsetLeftMobile={12} style={{ position: 'relative', cursor: 'pointer' }}>
            <EditIcon24 />
            <TeamUploadContainer team={currentTab} teamId={teamId ?? ''} fileInput={sip} fileInputRef={fileInputRef} />
          </FlexBox> */}
          <FlexBox offsetLeft={8} offsetLeftMobile={8}>
            <DeleteIcon fill={'#909090'} onClick={onDeleteTabBG} />
          </FlexBox>
        </FlexBox>
      </CoverWrapper>
    );
  }
  return null;
}, [hasTeamTabBG, teamId, sip, onDeleteTabBG, currentTab.titleImages]);

const coverBlock = useMemo(() => (
  <ProjectEditPageGridRow style={{ marginTop: isS ? 24 : 40 }} isTeamEdit>
    <CommonLabel
      label={t('teams.adminPage.fields.cover')}
      infoText={t('teams.adminPage.additionalFields.image_msg')}
      onWhiteBG
    />
    <ProjectEditPageGridInput isTeamEdit>
      {hasTeamTabBG ? teamBG : (
        <UploaderWrapper width={195} widthMobile={195} style={{ position: 'relative' }}>
          <DefaultButton wh={195} whMob={195}>
            {t('teams.adminPage.buttons.load')}
          </DefaultButton>
          <TeamUploadContainer team={team} teamId={teamId ?? ''} fileInput={sip} fileInputRef={fileInputRef} />
        </UploaderWrapper>
      )}
    </ProjectEditPageGridInput>
  </ProjectEditPageGridRow>
), [isS, t, teamId, sip, currentTab.titleImages, teamBG, hasTeamTabBG, team, currentTab]);


const onTeamCoverLinkChange = (value: { path?: string; newTab?: boolean; reset?: boolean }) => {
  let newCoverLink = currentTab.coverLink || { path: '', newTab: false };
  if (value.reset) {
    newCoverLink = { path: '', newTab: false };
  } else {
    newCoverLink = {
      ...newCoverLink,
      ...(value.path !== undefined ? { path: value.path } : {}),
      ...(value.newTab !== undefined ? { newTab: value.newTab } : {}),
    };
  }
  onTabChange({ ...currentTab, coverLink: newCoverLink });
};


const coverLinkBlock = useMemo(() => {
  const coverLink = currentTab.coverLink || { path: '', newTab: false };
  return (
    <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isTeamEdit>
      <ProjectEditPageGridList direction={'column'} directionMobile="column" isTeamEdit>
        {is1280 ? (
          <ProjectEditPageGridInput gyMobile={16} isTeamEdit directionMobile="column" justifyMobile="start" alignMobile="start">
            <CommonInput
              type={INPUT_TYPES.text}
              label={t('teams.adminPage.fields.cover_link')}
              infoText={t('teams.adminPage.additionalFields.cover_msg')}
              value={coverLink.path}
              placeholder={t('teams.adminPage.placeholders.adress')}
              onChange={(ev: any) => allowedCharacters(ev, (val: string) => onTeamCoverLinkChange({ path: val }))}
            />
            <FlexBox justify={'flex-start'}>
              <MagicBoxRow
                className="checkbox checkbox-with-label"
                checked={coverLink.newTab}
                label={t('teams.adminPage.additionalFields.new_tab')}
                onClick={() => onTeamCoverLinkChange({ newTab: !coverLink.newTab })}
                isTeamEdit
              />
            </FlexBox>
            {(coverLink.path && coverLink.path.length > 0) && (
              <FlexBox offsetLeftMobile={8}>
                <DefaultButton wh={131} whMob={107} onClick={() => onTeamCoverLinkChange({ reset: true })}>{t('teams.adminPage.buttons.delete')}</DefaultButton>
              </FlexBox>
            )}
          </ProjectEditPageGridInput>
        ) : (
          <JustTable isTeamEdit>
            <tr>
              <td style={{ width: 'auto', padding: isMobile ? '8px 12px 8px 0px' : 'inherit' }}>
                <TableSortWrapper direction={'row'} directionMobile="row" align={'center'}>
                  <CommonInput
                    type={INPUT_TYPES.text}
                    label={t('teams.adminPage.fields.cover_link')}
                    infoText={t('teams.adminPage.additionalFields.cover_msg')}
                    value={coverLink.path}
                    placeholder={t('teams.adminPage.placeholders.adress')}
                    onChange={(ev: any) => allowedCharacters(ev, (val: string) => onTeamCoverLinkChange({ path: val }))}
                  />
                </TableSortWrapper>
              </td>
              <td style={{ width: isS ? '70px' : '140px' }}>
                <FlexBox justify={'center'}>
                  <MagicBoxRow
                    className="checkbox checkbox-with-label"
                    checked={coverLink.newTab}
                    label={t('teams.adminPage.additionalFields.new_tab')}
                    onClick={() => onTeamCoverLinkChange({ newTab: !coverLink.newTab })}
                    isTeamEdit
                  />
                </FlexBox>
              </td>
              <td style={{ width: isS ? '56px' : '336px' }}>
                <FlexBox direction={'row'} directionMobile="row" gx={isS ? 0 : 24} gxMobile={isS ? 0 : 24} widthMobile={'100%'} justifyMobile={isS ? 'end' : 'start'}>
                  {(coverLink.path && coverLink.path.length > 0) && (
                    <DefaultButton wh={131} whMob={107} onClick={() => onTeamCoverLinkChange({ reset: true })}>{t('teams.adminPage.buttons.delete')}</DefaultButton>
                  )}
                </FlexBox>
              </td>
            </tr>
          </JustTable>
        )}
      </ProjectEditPageGridList>
    </ProjectEditPageGridRow>
  );
}, [currentTab, is1280, isMobile, isS, t, hasTeamTabBG]);

  if (type === TabType.shop) return <ProjectEditPageGrid isTeamPage offsetBottom={40}>
    {nameBlock}
    <ProjectEditPageGridRow style={{ marginTop: isS ? 24 : 40 }} isTeamEdit isCheckbox>
      <CommonLabel 
        label={t('teams.adminPage.fields.tab_default')}
        fixedHeight
      />
      <ProjectEditPageGridInput isTeamEdit isCheckbox>
        <MagicBoxRow
          checked={currentTab.isMain}
          label={''}
          onClick={() => onTabChange({ ...currentTab, isMain: !currentTab.isMain })}
          isTeamEdit
        />
      </ProjectEditPageGridInput>
    </ProjectEditPageGridRow>
    <TeamFilterEditView
      filter={currentTab.filter}
      onChange={(filter: ITeamFilterModel) => onTabChange({ ...currentTab, filter: filter })}
      isShopTagsOnly={true}
      isAdditional={true}
      isModer={isModer}
      isShopEditPage={true}
    />
  </ProjectEditPageGrid>

  return (
    <>
      {/*<PageViewportLayout offsetTop={40}>*/}

      <ProjectEditPageGrid isTeamPage offsetBottom={40}>

        <ProjectEditPageGridRow isTeamEdit>
          <CommonInput 
            type={INPUT_TYPES.text}
            orientation="wide"
            label={t('teams.adminPage.fields.tab_path')}
            required
            maxLength={100}
            value={currentTab.path}
            onChange={(ev: any) => allowedCharacters(ev, (val: string) => onTabChange({ ...currentTab, path: val }))}
          />
        </ProjectEditPageGridRow>
        {nameBlock}
        {!isLinksInsteadTitle && aboutBlock}
        {titleTypeBlock}
        {isLinksInsteadTitle && topLinksBlock}
        <ProjectEditPageGridRow style={{ marginTop: isS ? 24 : 40 }} isTeamEdit>
          <CommonInput 
            type={INPUT_TYPES.text}
            orientation="wide"
            placeholder={t('create.title_info.link_format')}
            label={t('teams.adminPage.fields.tab_href')}
            value={currentTab.href || ''}
            onChange={(ev: any) => validateUrlString(ev, (val: string) => onTabChange({ ...currentTab, href: val }))}
          />
        </ProjectEditPageGridRow>
        {gridTitleBlock}
        {gridTitleLinkBlock}
        {props.type === TabType.tab && !!props.categories?.length && (
          <ProjectEditPageGridRow style={{ marginTop: isS ? 24 : 40 }} isTeamEdit>
            <CommonInput 
              type={INPUT_TYPES.dropdown}
              orientation="wide"
              label={t('teams.adminPage.fields.tab_category')}
              options={categoryList}
              value={categoryList.find(({ value }) => value === currentTab.category)}
              onChange={(item: any) => onTabChange({ ...currentTab, category: item?.value })}
            />
          </ProjectEditPageGridRow>
        )}

        <ProjectEditPageGridRow style={{ marginTop: isS ? 24 : 40 }} isTeamEdit>
          <CommonInput 
              type={INPUT_TYPES.dropdown}
              orientation="wide"
              label={t('teams.adminPage.fields.tab_entity')}
              options={entityList}
              value={entityList.find(({ value }) => value === currentTab.entityType)}
              onChange={(item: any) => onTabChange({ ...currentTab, entityType: item?.value })}
              placeholder={t('teams.adminPage.fields.select_placeholder')}
          />
        </ProjectEditPageGridRow>
        {coverBlock}
        {hasTeamTabBG && coverLinkBlock}
        {buttonsBlock}
        {tab.entityType  && ['people_in_detail', 'people']?.includes(tab.entityType) && (
          <FlexBox gy={24} direction="column">
            <ProjectEditPageGridRow style={{ marginTop: 24 }} isTeamEdit>
              <CommonLabel 
                label={t('teams.adminPage.fields.rolesList')} fixedHeight />
              <ProjectEditPageGridInput isTeamEdit>
                <Input.Dropdown
                  isMulti
                  value={currentRoles}
                  onChange={(item: any) => {
                    const extractValues = item?.map(({ value }: { value: string}) => value )
                    onTabChange({ ...currentTab, filter: {...currentTab.filter, rolesList: extractValues } })
                  }}
                  options={rolesOptions}
                />
              </ProjectEditPageGridInput>
            </ProjectEditPageGridRow>
            <ProjectAuthorsEdit
              label={t('teams.adminPage.fields.random_user')}
              value={designers}
              onChange={onDesignersChange}
              placeholder={t('search_by_name')}
              isTeamEdit
              isAdminPage
              errorMsg={t('teams.adminPage.errors.equal_owners')}
            />
          </FlexBox>
        )}
        <ProjectEditPageGridRow style={{ marginTop: isS ? 24 : 40 }} isTeamEdit isCheckbox>
          <CommonLabel 
                label={t('teams.adminPage.fields.tab_default')} fixedHeight />
          <ProjectEditPageGridInput style={{ maxWidth: isS ? '40px' : '100%' }} isTeamEdit isCheckbox>
            <MagicBoxRow
              checked={currentTab.isMain}
              label={''}
              onClick={() => onTabChange({ ...currentTab, isMain: !currentTab.isMain })}
              isTeamEdit
            />
          </ProjectEditPageGridInput>
        </ProjectEditPageGridRow>
        <ProjectEditPageGridRow style={{ marginTop: isS ? 24 : 40 }} isTeamEdit isCheckbox>
          <CommonLabel 
                label={t('teams.adminPage.fields.tab_target_new_tab')} fixedHeight />
          <ProjectEditPageGridInput style={{ maxWidth: isS ? '40px' : '100%' }} isTeamEdit isCheckbox>
            <MagicBoxRow
                checked={currentTab.isOpenInNewTab}
                label={''}
                onClick={() => onTabChange({ ...currentTab, isOpenInNewTab: !currentTab.isOpenInNewTab })}
                isTeamEdit
            />
          </ProjectEditPageGridInput>
        </ProjectEditPageGridRow>
      </ProjectEditPageGrid>


      <TeamFilterEditView
        filter={currentTab.filter}
        onChange={(filter: ITeamFilterModel) => onTabChange({ ...currentTab, filter: filter })}
        isAdditional={true}
      />

      {/*</PageViewportLayout>*/}
    </>
  );
};
import { LangObject } from "@brg/api/dist/api-core/utils/lang-utils";
import React, { BaseSyntheticEvent, FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { ITeamFilterModel, TeamFilterEditView } from "./TeamFilterEditView";
//import { PageViewportLayout } from "shared/components/template";
import { ProjectEditPageGrid, ProjectEditPageGridRow } from "shared/pages/projectEdit/styles";
import { ProjectEditPageGridInput } from "_deziiign/books/pages/BookEdit/styles";
import { Input } from "@brg/input";
import { API, Designer, Endpoints, Lang, UploadFileAPI } from "@brg/api";
import { useTranslation } from "react-i18next";
import { CommonInput, CommonLabel, FlexBox, INPUT_TYPES, repeat, useBreakpoint, useIsMobile, useToasts } from "@brg/ui";
import { MagicBoxRow } from "shared/pages/project/components/toolsStyles";
import { LayoutConst, useModal } from "core";
import { allowedCharacters, buttonTypes, buttonTypesForModer, ITeamButton, ShowCaseTitleType, validateUrlString } from "../TeamEdit";
import { LangBlockWrapper, TeamEditLabel, UploaderWrapper, DefaultButton, MobileButtonsWrapper, GridMobileNamed, TeamsMobGridList, ActionsButton, TBody } from "../styles";
import { LangTitleBox } from "shared/components/LangTitleBox/LangTitleBox";
import { TabType } from "./TeamTabsBlock";
import { createEmptyLangObject } from "../../../components/__ADDONS__/__SAFEAPI__/Empty";
import ProjectAuthorsEdit, { ProjectAuthorsChangeCbT } from "shared/pages/projectEdit/ProjectAuthorsEdit";
import { useDesignerById } from "shared/hooks/api/useDesignerById";
import { useDesignerList } from "shared/hooks/api/useDesignersByProjects";
import { useDesignersAll } from "shared/hooks";
//@ts-ignore
import Switch from 'react-input-switch';
import TeamTopLinksBlock, { ITeamTopLink } from "./TeamTopLinksBlock";
import { useSimpleUploader } from '@brg/uploader';
import { TeamUploadContainer } from "../components/TeamUploadContainer";
import { CoverWrapper, TableSortWrapper } from "../styles";
import EditIcon24 from "shared/icons/EditIcon24";
import DeleteIcon from "shared/icons/DeleteIcon";
import { ProjectEditPageGridList } from "_deziiign/books/pages/BookEdit/styles";
import { JustTable, RequiredLabel, RequiredSpan } from "_competition/components/style";
import { SpecialDropdownButtons } from "./SpecialDropdownButtons";
import { InfoIcon } from "shared/components/InfoIcon/InfoIcon";
import PlusSvg from "shared/assets/32/PlusSvg";

const DESCRIPTION_MAX_LENGTH = 1000;

const setTextByLang = (
  current: LangObject[],
  lang: string,
  value: string
): LangObject[] => {
  const engValue = current.find(({ lang }) => lang === 'en') ?? {
    lang: 'en',
    name: '',
  };
  const ruValue = current.find(({ lang }) => lang === 'ru') ?? {
    lang: 'ru',
    name: '',
  };

  if (lang === 'ru') {
    return [{
      lang: 'ru',
      name: value,
    }, engValue];
  } else {
    return [ruValue, {
      lang: 'en',
      name: value,
    }];
  }
}

export interface ITeamTab {
  titleImages?: any;
  titleImageContainerId?: string;
  path: string;
  name: LangObject[];
  about: LangObject[];
  filter: ITeamFilterModel;
  isMain: boolean;
  currentLang?: string;
  entityType?: string;
  rolesList?: string[];
  designerIds?: string[];
  href?: string;
  isOpenInNewTab: boolean;
  category?: string;
  gridTitle: LangObject[];
  gridTitleLink: LangObject[];
  topLinks?: ITeamTopLink[]; 
  isLinksShow?: boolean; 
  coverLink?: { path: string; newTab: boolean };
  buttons?: any[];
}

type TeamTabEditPropsT = {
  type?: TabType,
  isModer?: boolean,
  categories?: ITeamTab[],
  tab: ITeamTab,
  onChange?: (tab: ITeamTab) => void;
  teamId?: string;
  team?: any;
  anchorTypes?: any;
  actualForms?: any;
  tabIndex?: number;
  maxLGButtonsCount?: number;
  updateTeam: () => void;
  setIsChangesSaved?: (saved: boolean) => void;
}

export const TeamTabEdit: FC<TeamTabEditPropsT> = (props) => {
  const { t, i18n } = useTranslation();
  const is1280 = useBreakpoint(LayoutConst.screen.l_12);
  const toasts = useToasts();
  const isMobile = useIsMobile();
  const isS = useBreakpoint(LayoutConst.screen.s);
  const modal = useModal();

  const { tab, onChange, type, categories, isModer, teamId, tabIndex, updateTeam, team, anchorTypes, actualForms, maxLGButtonsCount=0, setIsChangesSaved } = props;

  const [currentTab, setCurrentTab] = useState<ITeamTab>(tab);
  const [designers, setDesigners] = useState<Designer[]>([]);

  // Обновляем currentTab когда изменяется tab
  useEffect(() => {
    setCurrentTab(tab);
  }, [tab]);

  const [showCaseTitleType, setShowCaseTitleType] = useState(ShowCaseTitleType.text);
  const [isLinksInsteadTitle, setIsLinksInsteadTitle] = useState(
    currentTab.isLinksShow ?? false
  );
  const [topLinks, setTopLinks] = useState<ITeamTopLink[]>(currentTab.topLinks || []);
  const [tabButtons, setTabButtons] = useState(currentTab.buttons || []);
  const [isDeletingButton, setIsDeletingButton] = useState(false);
  const titleRef = useRef<any>();
  const MAX_TOP_LINKS_COUNT = 5;
  const fileInputRef = useRef<HTMLInputElement>(null);
  const sipRef = useRef<any>(null);
  const hasTeamTabBG = useMemo(() => !!currentTab?.titleImages?.length, [currentTab, team]);
  const onTabChange = useCallback((changedTab: ITeamTab) => {
    setCurrentTab(changedTab);
    onChange?.(changedTab);
  }, [onChange]);

  const onSetTopLinks = useCallback((val: any) => {
    if (val?.length > MAX_TOP_LINKS_COUNT && val) {
        toasts.error(`Максимальное количество заглавных ссылок: ${MAX_TOP_LINKS_COUNT}`);
        return;
    }
    setTopLinks(val)
    onTabChange({ ...currentTab, topLinks: val });
}, [currentTab, onTabChange])
  
  const onTitleVisibleChange = useCallback(() => {
    if (showCaseTitleType) {
        setShowCaseTitleType(ShowCaseTitleType.text);
        setIsLinksInsteadTitle(false);
    } else {
        setShowCaseTitleType(ShowCaseTitleType.link);
        setIsLinksInsteadTitle(true);
        if (topLinks?.length === 0) {
          setTopLinks([{
              name: createEmptyLangObject('', ['ru', 'en']),
              link: ''
          }]);
      }
    }
    
    onTabChange({ ...currentTab, isLinksShow: !isLinksInsteadTitle});
}, [showCaseTitleType, topLinks]);



  const onDesignersChange = ({ authors }: ProjectAuthorsChangeCbT) => {
    onTabChange({ 
      ...currentTab, 
      filter: {
        ...currentTab.filter, 
        designerIds: authors?.map(({ designerId }) => designerId) 
      } 
    })
  }

  useEffect(() => {
    if (!!tab?.filter?.designerIds?.length) {
      API.request()
      .endpoint(Endpoints.geograffee)
      .url('api/Designer/GetList')
      .addQuery('designerIds', tab?.filter?.designerIds)
      .get()
      .send()
      .then((r) => r.json())
      .then((r) => setDesigners(API.toLang(r.data, i18n.language)))
    } else {
      setDesigners([])
    }
  } , [tab, i18n])

  const onLocalLangChange = (arr: any[], lang: string, callback: (test: any[]) => void) => callback(arr?.map((i: any) => ({
    ...i,
    currentLang: lang === 'ru' ? 'en' : 'ru'
  })));

  const categoryList = useMemo(() => {
    if (type === TabType.tab && categories) {
      return categories.map(({ path }) => ({
        label: path,
        value: path
      }))
    }
    return []
  }, [type, categories]);

  const entityList = useMemo(() => {
    return [{
      label: t('teams.adminPage.entities.projects'),
      value: 'projects'
    }, {
      label: t('teams.adminPage.entities.cached_projects'),
      value: 'main'
    }, {
      label: t('teams.adminPage.entities.teams'),
      value: 'organizations',
    }, {
        label: t('teams.adminPage.entities.competitions'),
        value: 'competitions_new',
    }, {
      label: t('teams.adminPage.entities.modules'),
      value: 'modules',
    }, {
      label: t('teams.adminPage.entities.people'),
      value: 'people',
    }, {
      label: t('teams.adminPage.entities.people_in_detail'),
      value: 'people_in_detail',
    }
  ]
  }, [t])

  const currentRoles = useMemo(() => {
    //@ts-ignore
    return currentTab?.filter?.rolesList?.reduce((acc, val) => [...acc, { label: val, value: val }], []) || []
  }, [currentTab])

  const rolesOptions = useMemo(() => {
    //@ts-ignore
    return [
      { label: 'expertmoder', value: 'expertmoder'},
      { label: 'dafessovet', value: 'dafessovet'}
    ]
  }, [])


  useEffect(() => {
    setTabButtons(currentTab.buttons || []);
  }, [currentTab.buttons]);

  const onTabButtonChange = (button: ITeamButton, idx: number) => {
    const newButtons = tabButtons.map((b, i) => (i === idx ? button : b));
    setTabButtons(newButtons);
    onTabChange({ ...currentTab, buttons: newButtons });
  };
  const onTabButtonAdd = () => {
    const newButtons = [
      ...tabButtons,
      {
            type: 'filled',
            text: createEmptyLangObject('', ['ru', 'en']),
            textMobile: createEmptyLangObject('', ['ru', 'en']),
            href: createEmptyLangObject('', ['ru', 'en']),
            isRequired: false,
            actionType: '',
            anchor: { label: '', value: '' },
        },
    ];
    setTabButtons(newButtons);
    onTabChange({ ...currentTab, buttons: newButtons });
  };
  const onTabButtonDelete = (idx: number) => {
    setIsDeletingButton(true);
    const newButtons = tabButtons.filter((_, i) => i !== idx);
    setTabButtons(newButtons);
    onTabChange({ ...currentTab, buttons: newButtons });
    setIsChangesSaved?.(true);
    setTimeout(() => {
      setIsDeletingButton(false);
    }, 500);
  };
  const onTabButtonLangChange = (lang: string) => {
    const newButtons = tabButtons.map((b) => ({ ...b, currentLang: lang }));
    setTabButtons(newButtons);
    onTabChange({ ...currentTab, buttons: newButtons });
  };

  const buttonsBlock = useMemo(() => {
    const currentLang = tabButtons?.find((button) => button?.currentLang)?.currentLang || 'ru';
    return (
      <LangBlockWrapper offsetTop={40} offsetTopMobile={isS ? 24 : 40} direction={is1280 ? 'column' : 'row'} directionMobile={isMobile ? 'column' : 'row'}>
        <CommonLabel
          label={t('teams.adminPage.fields.page_buttons')}
          onLanguageChange={() => onTabButtonLangChange(currentLang === 'ru' ? 'en' : 'ru')}
          lang={currentLang}
          useLangSwitcher={!!tabButtons?.length}
          fixedHeight
          onWhiteBG
        />
        <ProjectEditPageGridRow directionMobile={!!tabButtons?.length ? 'column' : 'row'} isTeamEdit>
          <ProjectEditPageGridList direction={'column'} directionMobile="column" isTeamEdit>
            {!tabButtons?.length && (
              <FlexBox direction={'row'} directionMobile="row" style={{ marginBottom: !tabButtons?.length ? 0 : 24 }}>
                <DefaultButton wh={195} whMob={195} onClick={onTabButtonAdd}>
                  {/* <PlusSvg /> */}
                  {t('teams.adminPage.buttons.create')}
                </DefaultButton>
              </FlexBox>
            )}
            {(!!tabButtons?.length) && (
                                        <>
                                        {isMobile ? (
                                            <>
                                                {tabButtons.map((button, index) => {
                                                    return (
                                                        <MobileButtonsWrapper directionMobile="row" gxMobile={24} offsetTopMobile={24} >
                                                            {isS && (
                                                                <GridMobileNamed>
                                                                    <span>{`Кнопка ${index + 1}`}</span>
                                                                    {button.isRequired ? (
                                                                         <FlexBox justify={'flex-start'} width={'100px'}>
                                                                        </FlexBox>
                                                                    ) : (
                                                                         <DefaultButton wh={131} whMob={107} onClick={() => onTabButtonDelete(index)} isTablet disabled={isDeletingButton}>Удалить</DefaultButton>
                                                                    )}
                                                                </GridMobileNamed>
                                                            )}
                                                            <TeamsMobGridList isTeamEditButtons cols={repeat(2, isMobile ? '260px' : '306.5px')} >
                                                                <CommonInput 
                                                                    type={INPUT_TYPES.dropdown}
                                                                    orientation="column"
                                                                    label={t('teams.adminPage.additionalFields.td_style')}
                                                                    value={{ label: button.type, value: button.type }}
                                                                    onChange={(value: any) => onTabButtonChange({ ...button, type: value.value }, index)}
                                                                    options={isModer ? buttonTypesForModer : buttonTypes}
                                                                />
                                                                <CommonInput 
                                                                    type={INPUT_TYPES.text}
                                                                    orientation="column"
                                                                    label={t('teams.adminPage.additionalFields.td_text')}
                                                                    value={Lang(button.text, currentLang)}
                                                                    onChange={(value: any) => onTabButtonChange({ ...button, text: setTextByLang(button.text, currentLang, value.target.value)}, index)}
                                                                />
                                                                <CommonInput 
                                                                    type={INPUT_TYPES.text}
                                                                    orientation="column"
                                                                    label={t('teams.adminPage.additionalFields.td_text_mobile')}
                                                                    value={Lang(button.textMobile, currentLang)}
                                                                    onChange={(value: any) => onTabButtonChange({ ...button, textMobile: setTextByLang(button.textMobile, currentLang, value.target.value)}, index)}
                                                                />
            
                                                                <FlexBox  directionMobile="column">
                                                                    <CommonLabel 
                                                                        label={t('teams.adminPage.additionalFields.td_href')}
                                                                        fixedHeight
                                                                        onWhiteBG
                                                                    />
                                                                    <ProjectEditPageGridInput isTeamEdit isColumns>
                                                                        {button.type?.includes('anchor') ? (
                                                                            <CommonInput 
                                                                                type={INPUT_TYPES.dropdown}
                                                                                orientation="column"
                                                                                value={{ label: button.type, value: button.type }}
                                                                                onChange={(value: any) => onTabButtonChange({ ...button, type: value.value }, index)}
                                                                                options={isModer ? buttonTypesForModer : buttonTypes}
                                                                            />
                                                                        ) : (
                                                                            <>
                                                                                {!!button?.isRequired ? (
                                                                                    <ActionsButton>{t(`teams.adminPage.additionalFields.button_${button.actionType}`)}</ActionsButton>
                                                                                ) : (
                                                                                    <SpecialDropdownButtons
                                                                                        currentLang={currentLang}
                                                                                        button={button}
                                                                                        index={index} 
                                                                                        onChange={onTabButtonChange}
                                                                                        actualForms={actualForms}
                                                                                    />
                                                                                )}
                                                                            </>
                                                                        )}
            
                                                                        </ProjectEditPageGridInput>
                                                                    </FlexBox>
                                                                </TeamsMobGridList>
                                                                {!isS && (
                                                                    <>
                                                                        {!!button?.isRequired ? (
                                                                            <FlexBox justify={'flex-start'} style={{ height: '88px' }}>
                                                                            </FlexBox>
                                                                        ) : (
                                                                            <DefaultButton style={{ marginTop: isMobile ? '26px' : 0 }} wh={131} whMob={107} onClick={() => onTabButtonDelete(index)} disabled={isDeletingButton}>{t('teams.adminPage.buttons.delete')}</DefaultButton>
                                                                        )}
            
                                                                    </>
                                                                )}
                                                            </MobileButtonsWrapper>
                                                        )
                                                    })}
                                                </>
                                        ) : (
                                            <JustTable isTeamEdit>
                                                <thead>
                                                    <tr>
                                                        <RequiredLabel style={{width: '20%'}} className={'required-label'}>{t('teams.adminPage.additionalFields.td_style')}</RequiredLabel>
                                                        <RequiredLabel style={{width: '25%'}} className={'required-label'}>{t('teams.adminPage.additionalFields.td_text')}</RequiredLabel>
                                                        <th style={{width: '25%'}}>{t('teams.adminPage.additionalFields.td_text_mob')}</th>
                                                        <th style={{width: '25%'}}>
                                                            <FlexBox align="center" gx={4}>
                                                                <RequiredSpan className={'required-label'}>{t('teams.adminPage.additionalFields.td_href')}</RequiredSpan> 
                                                                <InfoIcon stc msg={t('teams.adminPage.additionalFields.team_context_link')} />
                                                            </FlexBox>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <TBody>
                                                    {tabButtons.map((button, index) => {
                                                        return (
                                                            <tr>
                                                                <td style={{width: '195px'}}>
                                                                    <CommonInput 
                                                                        type={INPUT_TYPES.dropdown}
                                                                        value={{ label: t(`teams.adminPage.additionalFields.${button.type}`), value: button.type }}
                                                                        onChange={(value: any) => onTabButtonChange({ ...button, type: value.value }, index)}
                                                                         options={(isModer ? buttonTypesForModer : buttonTypes).map(option => ({
                                                                            label: t(`teams.adminPage.additionalFields.${option.label}`),
                                                                            value: option.value
                                                                        }))}
                                                                    />
                                                                </td>
                                                                <td style={{width: '180px'}}>
                                                                    <CommonInput 
                                                                        type={INPUT_TYPES.text}
                                                                        value={Lang(button.text, currentLang)}
                                                                        onChange={(value: any) => onTabButtonChange({ ...button, text: setTextByLang(button.text, currentLang, value.target.value)}, index)}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <CommonInput 
                                                                        type={INPUT_TYPES.text}
                                                                        value={Lang(button.textMobile, currentLang)}
                                                                        onChange={(value: any) => onTabButtonChange({ ...button, textMobile: setTextByLang(button.textMobile, currentLang, value.target.value)}, index)}
                                                                    />
                                                                </td>
                                                                    <>
                                                                    <td>
                                                                        {button.type?.includes('anchor') ? (
                                                                            <>
                                                                                {!!anchorTypes?.length ? (
                                                                                    <CommonInput 
                                                                                        type={INPUT_TYPES.dropdown}
                                                                                        value={button.anchor}
                                                                                        onChange={(value: any) => onTabButtonChange({ ...button, anchor: value}, index)}
                                                                                        options={anchorTypes}
                                                                                    />
                                                                                ) : (
                                                                                    <ActionsButton>{t('teams.adminPage.additionalFields.anchor_not_exist')}</ActionsButton>
                                                                                )}
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                {!!button?.isRequired ? (
                                                                                    <ActionsButton>{t(`teams.adminPage.additionalFields.button_${button.actionType}`)}</ActionsButton>
                                                                                ) : (
                                                                                    <SpecialDropdownButtons
                                                                                        currentLang={currentLang}
                                                                                        button={button}
                                                                                        index={index} 
                                                                                        onChange={onTabButtonChange}
                                                                                        actualForms={actualForms}
                                                                                    />
                                                                                )}
                                                                            </>
                                                                        )}
                                                                    </td>
            
                                                                        <td>
                                                                            {!!button?.isRequired ? (
                                                                                <FlexBox justify={'flex-start'}>
            
                                                                                </FlexBox>
                                                                            ) : (
                                                                                <DefaultButton wh={131} whMob={107} onClick={() => onTabButtonDelete(index)} disabled={isDeletingButton}>{t('teams.adminPage.buttons.delete')}</DefaultButton>
                                                                            )}
                                                                        </td>
                                                                    </>
                                                                </tr>
                                                            );
                                                        })}
                                                    </TBody>
                                                </JustTable>
                                            )}
                                        </>
                                    )}
            {!!tabButtons?.length && tabButtons?.length < maxLGButtonsCount && (
              <FlexBox direction={'row'} directionMobile="row" style={{ marginTop: 16 }}>
                <DefaultButton wh={195} whMob={195} onClick={onTabButtonAdd}>
                  <PlusSvg />
                  {t('teams.adminPage.buttons.add')}
                </DefaultButton>
              </FlexBox>
            )}
          </ProjectEditPageGridList>
        </ProjectEditPageGridRow>
      </LangBlockWrapper>
    );
  }, [tabButtons, isS, t, is1280, isMobile, maxLGButtonsCount]);


  const nameBlock = useMemo(() => {
    return (
      <LangBlockWrapper offsetTop={40} offsetTopMobile={isS ? 24 : 40} direction="row"
                        directionMobile={isS ? 'column' : 'row'}>

        <CommonInput 
          type={INPUT_TYPES.text}
          label={t('teams.adminPage.fields.name')}
          orientation="wide"
          useLangSwitcher
          value={currentTab.name}
          maxLength={100}
          onChange={(ev: any, lang?: string) => {
            onTabChange(
              { ...currentTab, name: setTextByLang(currentTab.name, lang ?? 'ru', ev.target.value) })
          }
          }

        />
      </LangBlockWrapper>
    )
  }, [currentTab, isMobile, isS])

  const aboutBlock = useMemo(() => {
    return (
      <LangBlockWrapper offsetTop={40} offsetTopMobile={isS ? 24 : 40} direction="row"
                        directionMobile={isS ? 'column' : 'row'}>
        <CommonInput 
          maxLength={DESCRIPTION_MAX_LENGTH}
          type={INPUT_TYPES.textarea}
          label={t('teams.adminPage.fields.tab_description')}
          useLangSwitcher
          value={currentTab.about}
          onChange={(value: any, lang?: string) => onTabChange({
            ...currentTab,
            about: setTextByLang(currentTab.about, lang ?? 'ru', value.target.value)
          })}
        />
      </LangBlockWrapper>
    )
  }, [currentTab, isMobile, isS])

  const gridTitleBlock = useMemo(() => {
    return (
      <LangBlockWrapper offsetTop={40} offsetTopMobile={isS ? 24 : 40} direction="row"
                        directionMobile={isS ? 'column' : 'row'}>
        <CommonInput 
          type={INPUT_TYPES.text}
          label={t('teams.adminPage.fields.grid_title')}
          useLangSwitcher
          value={currentTab.gridTitle || createEmptyLangObject('', ['ru', 'en'])}
          onChange={(ev: any, lang?: string) => {
            onTabChange(
              { ...currentTab, gridTitle: setTextByLang((currentTab.gridTitle || createEmptyLangObject('', ['ru', 'en'])), lang ?? 'ru', ev.target.value) })
          }
          }
        />
      </LangBlockWrapper>
    )
  }, [currentTab, isMobile, isS])

  const gridTitleLinkBlock = useMemo(() => {
    return (
      <LangBlockWrapper offsetTop={40} offsetTopMobile={isS ? 24 : 40} direction="row"
                        directionMobile={isS ? 'column' : 'row'}>

        <CommonInput 
          type={INPUT_TYPES.text}
          label={t('teams.adminPage.fields.grid_title_link')}
          useLangSwitcher
          value={currentTab.gridTitleLink || createEmptyLangObject('', ['ru', 'en'])}
          onChange={(ev: any, lang?: string) => {
            onTabChange(
              { ...currentTab, gridTitleLink: setTextByLang((currentTab.gridTitleLink || createEmptyLangObject('', ['ru', 'en'])), lang ?? 'ru', ev.target.value) })
          }
          }
        />
      </LangBlockWrapper>
    )
  }, [currentTab, isMobile, isS])
  
  const titleTypeBlock = useMemo(() => {
    return (
        <ProjectEditPageGridRow align="flex-start" style={{marginTop: isS ? 24 : 40}} isTeamEdit switchValue={showCaseTitleType} >
            <CommonLabel 
              label={t('teams.adminPage.additionalFields.header_show')}
              fixedHeight
            />
            <FlexBox ref={titleRef} direction={isS ? "column" : "row"} justify="space-between" align={isS ? "start": "center"} width={isS ? '100%' : '600px'} style={{ maxWidth: '600px', flexDirection: isS ? "column" : "row"}}>
                        <FlexBox direction="row" directionMobile="row" gx={16} gxMobile={16} offsetBottomMobile={8}>
                            <span className={'input-span'}> {t('teams.adminPage.additionalFields.header_title_text')}</span>
                            <Switch className={'showcase-switcher'} value={showCaseTitleType} onChange={onTitleVisibleChange} />
                            <span className={'input-span'}> {t('teams.adminPage.additionalFields.header_title_link')}</span>
                        </FlexBox>
            </FlexBox>
        </ProjectEditPageGridRow>
    )
},[isS, showCaseTitleType, onTitleVisibleChange, t])

const topLinksBlock = useMemo(() => {
  return (
    <TeamTopLinksBlock
      isMobile={isMobile}
      isS={isS}
      is1280={is1280}
      topLinks={topLinks}
      setTopLinks={onSetTopLinks}
      onLocalLangChange={onLocalLangChange}
    />
  )
}, [topLinks, isMobile, isS, is1280, onSetTopLinks])


const uploaderCallback = useCallback(
  (fileId: string) => {
    if (!fileId || teamId === null || tabIndex === null) return null;
    return UploadFileAPI.Upload({
      fileId,
      profileId: teamId,
      service: 'geography',
      entityType: `geographyteamavatartab_${tabIndex}`,
      localization: i18n.language,
    }).then((res: any) => {
       sipRef.current.uploader.uploader.uppy.reset();
      updateTeam();
      if (res?.data?.titleImages) {
        onTabChange({ ...currentTab, titleImages: res.data.titleImages });
      }
      return res;
    });
  },
  [teamId, tabIndex, i18n.language, hasTeamTabBG, updateTeam, currentTab, onTabChange]
);

const uploadValidator = useCallback(async (files: any) => {
  let failedChecks: {
    dimensions?: boolean;
    size?: boolean;
    ratio?: boolean;
    type?: boolean;
  } = {};

  const loadFile = () => new Promise<{width: number, height: number}>((resolve, reject) => {
    const fr = new FileReader();
    fr.onload = function () {
      const img = new Image();
      img.onload = function () {
        const { width, height } = img;
        resolve({ width, height });
      };
      // @ts-ignore
      img.src = fr.result;
    };
    fr.readAsDataURL(files[0]);
  });

  // @ts-ignore
  const { height, width } = await loadFile();

  if (!['image/jpeg'].includes(files?.[0]?.type)) {
    toasts.error('Допустимые форматы: jpg');
    failedChecks.type = true;
  }

  const { size: failedSize, dimensions: failedDimensions, ratio: failedRatio, type: failedType } = failedChecks;

  if (failedSize || failedDimensions || failedRatio || failedType) {
     sipRef.current.uploader.inputRef.current.value = '';
    return false;
  }

  return true;
}, [toasts, fileInputRef, hasTeamTabBG]);
const sip = useSimpleUploader(uploaderCallback, uploadValidator);
 sipRef.current = sip;


const onDeleteTabBG = useCallback(() => {
  modal.show('confirmDeleteCoverModal', {
    teamId: teamId ?? '',
    teamBGLang: false,
    tabIndex: tabIndex,
    isTabImg: true,
    onDelete: updateTeam,
    handleClose: modal.hide,
    entityType: `geographyteamavatartab_${tabIndex}`,
  });
}, [teamId, currentTab?.titleImages, updateTeam, tabIndex, team]);

const teamBG = useMemo(() => {
  if (hasTeamTabBG) {
    return (
      <CoverWrapper justify="flex-start" direction="column" directionMobile="column" align={'flex-start'} alignMobile="flex-start">
        <FlexBox className={'cover-container'} direction={'row'} directionMobile="row" offsetTopMobile={10}>
          <span>{currentTab.titleImages?.[0]?.url?.split('/').slice(-1)}</span>
          {/* <FlexBox direction="row" directionMobile="row" offsetLeft={12} offsetLeftMobile={12} style={{ position: 'relative', cursor: 'pointer' }}>
            <EditIcon24 />
            <TeamUploadContainer team={currentTab} teamId={teamId ?? ''} fileInput={sip} fileInputRef={fileInputRef} />
          </FlexBox> */}
          <FlexBox offsetLeft={8} offsetLeftMobile={8}>
            <DeleteIcon fill={'#909090'} onClick={onDeleteTabBG} />
          </FlexBox>
        </FlexBox>
      </CoverWrapper>
    );
  }
  return null;
}, [hasTeamTabBG, teamId, sip, onDeleteTabBG, currentTab.titleImages]);

const coverBlock = useMemo(() => (
  <ProjectEditPageGridRow style={{ marginTop: isS ? 24 : 40 }} isTeamEdit>
    <CommonLabel
      label={t('teams.adminPage.fields.cover')}
      infoText={t('teams.adminPage.additionalFields.image_msg')}
      onWhiteBG
    />
    <ProjectEditPageGridInput isTeamEdit>
      {hasTeamTabBG ? teamBG : (
        <UploaderWrapper width={195} widthMobile={195} style={{ position: 'relative' }}>
          <DefaultButton wh={195} whMob={195}>
            {t('teams.adminPage.buttons.load')}
          </DefaultButton>
          <TeamUploadContainer team={team} teamId={teamId ?? ''} fileInput={sip} fileInputRef={fileInputRef} />
        </UploaderWrapper>
      )}
    </ProjectEditPageGridInput>
  </ProjectEditPageGridRow>
), [isS, t, teamId, sip, currentTab.titleImages, teamBG, hasTeamTabBG, team, currentTab]);


const onTeamCoverLinkChange = (value: { path?: string; newTab?: boolean; reset?: boolean }) => {
  let newCoverLink = currentTab.coverLink || { path: '', newTab: false };
  if (value.reset) {
    newCoverLink = { path: '', newTab: false };
  } else {
    newCoverLink = {
      ...newCoverLink,
      ...(value.path !== undefined ? { path: value.path } : {}),
      ...(value.newTab !== undefined ? { newTab: value.newTab } : {}),
    };
  }
  onTabChange({ ...currentTab, coverLink: newCoverLink });
};


const coverLinkBlock = useMemo(() => {
  const coverLink = currentTab.coverLink || { path: '', newTab: false };
  return (
    <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isTeamEdit>
      <ProjectEditPageGridList direction={'column'} directionMobile="column" isTeamEdit>
        {is1280 ? (
          <ProjectEditPageGridInput gyMobile={16} isTeamEdit directionMobile="column" justifyMobile="start" alignMobile="start">
            <CommonInput
              type={INPUT_TYPES.text}
              label={t('teams.adminPage.fields.cover_link')}
              infoText={t('teams.adminPage.additionalFields.cover_msg')}
              value={coverLink.path}
              placeholder={t('teams.adminPage.placeholders.adress')}
              onChange={(ev: any) => allowedCharacters(ev, (val: string) => onTeamCoverLinkChange({ path: val }))}
            />
            <FlexBox justify={'flex-start'}>
              <MagicBoxRow
                className="checkbox checkbox-with-label"
                checked={coverLink.newTab}
                label={t('teams.adminPage.additionalFields.new_tab')}
                onClick={() => onTeamCoverLinkChange({ newTab: !coverLink.newTab })}
                isTeamEdit
              />
            </FlexBox>
            {(coverLink.path && coverLink.path.length > 0) && (
              <FlexBox offsetLeftMobile={8}>
                <DefaultButton wh={131} whMob={107} onClick={() => onTeamCoverLinkChange({ reset: true })}>{t('teams.adminPage.buttons.delete')}</DefaultButton>
              </FlexBox>
            )}
          </ProjectEditPageGridInput>
        ) : (
          <JustTable isTeamEdit>
            <tr>
              <td style={{ width: 'auto', padding: isMobile ? '8px 12px 8px 0px' : 'inherit' }}>
                <TableSortWrapper direction={'row'} directionMobile="row" align={'center'}>
                  <CommonInput
                    type={INPUT_TYPES.text}
                    label={t('teams.adminPage.fields.cover_link')}
                    infoText={t('teams.adminPage.additionalFields.cover_msg')}
                    value={coverLink.path}
                    placeholder={t('teams.adminPage.placeholders.adress')}
                    onChange={(ev: any) => allowedCharacters(ev, (val: string) => onTeamCoverLinkChange({ path: val }))}
                  />
                </TableSortWrapper>
              </td>
              <td style={{ width: isS ? '70px' : '140px' }}>
                <FlexBox justify={'center'}>
                  <MagicBoxRow
                    className="checkbox checkbox-with-label"
                    checked={coverLink.newTab}
                    label={t('teams.adminPage.additionalFields.new_tab')}
                    onClick={() => onTeamCoverLinkChange({ newTab: !coverLink.newTab })}
                    isTeamEdit
                  />
                </FlexBox>
              </td>
              <td style={{ width: isS ? '56px' : '336px' }}>
                <FlexBox direction={'row'} directionMobile="row" gx={isS ? 0 : 24} gxMobile={isS ? 0 : 24} widthMobile={'100%'} justifyMobile={isS ? 'end' : 'start'}>
                  {(coverLink.path && coverLink.path.length > 0) && (
                    <DefaultButton wh={131} whMob={107} onClick={() => onTeamCoverLinkChange({ reset: true })}>{t('teams.adminPage.buttons.delete')}</DefaultButton>
                  )}
                </FlexBox>
              </td>
            </tr>
          </JustTable>
        )}
      </ProjectEditPageGridList>
    </ProjectEditPageGridRow>
  );
}, [currentTab, is1280, isMobile, isS, t, hasTeamTabBG]);

  if (type === TabType.shop) return <ProjectEditPageGrid isTeamPage offsetBottom={40}>
    {nameBlock}
    <ProjectEditPageGridRow style={{ marginTop: isS ? 24 : 40 }} isTeamEdit isCheckbox>
      <CommonLabel 
        label={t('teams.adminPage.fields.tab_default')}
        fixedHeight
      />
      <ProjectEditPageGridInput isTeamEdit isCheckbox>
        <MagicBoxRow
          checked={currentTab.isMain}
          label={''}
          onClick={() => onTabChange({ ...currentTab, isMain: !currentTab.isMain })}
          isTeamEdit
        />
      </ProjectEditPageGridInput>
    </ProjectEditPageGridRow>
    <TeamFilterEditView
      filter={currentTab.filter}
      onChange={(filter: ITeamFilterModel) => onTabChange({ ...currentTab, filter: filter })}
      isShopTagsOnly={true}
      isAdditional={true}
      isModer={isModer}
      isShopEditPage={true}
    />
  </ProjectEditPageGrid>

  return (
    <>
      {/*<PageViewportLayout offsetTop={40}>*/}

      <ProjectEditPageGrid isTeamPage offsetBottom={40}>

        <ProjectEditPageGridRow isTeamEdit>
          <CommonInput 
            type={INPUT_TYPES.text}
            orientation="wide"
            label={t('teams.adminPage.fields.tab_path')}
            required
            maxLength={100}
            value={currentTab.path}
            onChange={(ev: any) => allowedCharacters(ev, (val: string) => onTabChange({ ...currentTab, path: val }))}
          />
        </ProjectEditPageGridRow>
        {nameBlock}
        {!isLinksInsteadTitle && aboutBlock}
        {titleTypeBlock}
        {isLinksInsteadTitle && topLinksBlock}
        <ProjectEditPageGridRow style={{ marginTop: isS ? 24 : 40 }} isTeamEdit>
          <CommonInput 
            type={INPUT_TYPES.text}
            orientation="wide"
            placeholder={t('create.title_info.link_format')}
            label={t('teams.adminPage.fields.tab_href')}
            value={currentTab.href || ''}
            onChange={(ev: any) => validateUrlString(ev, (val: string) => onTabChange({ ...currentTab, href: val }))}
          />
        </ProjectEditPageGridRow>
        {gridTitleBlock}
        {gridTitleLinkBlock}
        {props.type === TabType.tab && !!props.categories?.length && (
          <ProjectEditPageGridRow style={{ marginTop: isS ? 24 : 40 }} isTeamEdit>
            <CommonInput 
              type={INPUT_TYPES.dropdown}
              orientation="wide"
              label={t('teams.adminPage.fields.tab_category')}
              options={categoryList}
              value={categoryList.find(({ value }) => value === currentTab.category)}
              onChange={(item: any) => onTabChange({ ...currentTab, category: item?.value })}
            />
          </ProjectEditPageGridRow>
        )}

        <ProjectEditPageGridRow style={{ marginTop: isS ? 24 : 40 }} isTeamEdit>
          <CommonInput 
              type={INPUT_TYPES.dropdown}
              orientation="wide"
              label={t('teams.adminPage.fields.tab_entity')}
              options={entityList}
              value={entityList.find(({ value }) => value === currentTab.entityType)}
              onChange={(item: any) => onTabChange({ ...currentTab, entityType: item?.value })}
              placeholder={t('teams.adminPage.fields.select_placeholder')}
          />
        </ProjectEditPageGridRow>
        {coverBlock}
        {hasTeamTabBG && coverLinkBlock}
        {buttonsBlock}
        {tab.entityType  && ['people_in_detail', 'people']?.includes(tab.entityType) && (
          <FlexBox gy={24} direction="column">
            <ProjectEditPageGridRow style={{ marginTop: 24 }} isTeamEdit>
              <CommonLabel 
                label={t('teams.adminPage.fields.rolesList')} fixedHeight />
              <ProjectEditPageGridInput isTeamEdit>
                <Input.Dropdown
                  isMulti
                  value={currentRoles}
                  onChange={(item: any) => {
                    const extractValues = item?.map(({ value }: { value: string}) => value )
                    onTabChange({ ...currentTab, filter: {...currentTab.filter, rolesList: extractValues } })
                  }}
                  options={rolesOptions}
                />
              </ProjectEditPageGridInput>
            </ProjectEditPageGridRow>
            <ProjectAuthorsEdit
              label={t('teams.adminPage.fields.random_user')}
              value={designers}
              onChange={onDesignersChange}
              placeholder={t('search_by_name')}
              isTeamEdit
              isAdminPage
              errorMsg={t('teams.adminPage.errors.equal_owners')}
            />
          </FlexBox>
        )}
        <ProjectEditPageGridRow style={{ marginTop: isS ? 24 : 40 }} isTeamEdit isCheckbox>
          <CommonLabel 
                label={t('teams.adminPage.fields.tab_default')} fixedHeight />
          <ProjectEditPageGridInput style={{ maxWidth: isS ? '40px' : '100%' }} isTeamEdit isCheckbox>
            <MagicBoxRow
              checked={currentTab.isMain}
              label={''}
              onClick={() => onTabChange({ ...currentTab, isMain: !currentTab.isMain })}
              isTeamEdit
            />
          </ProjectEditPageGridInput>
        </ProjectEditPageGridRow>
        <ProjectEditPageGridRow style={{ marginTop: isS ? 24 : 40 }} isTeamEdit isCheckbox>
          <CommonLabel 
                label={t('teams.adminPage.fields.tab_target_new_tab')} fixedHeight />
          <ProjectEditPageGridInput style={{ maxWidth: isS ? '40px' : '100%' }} isTeamEdit isCheckbox>
            <MagicBoxRow
                checked={currentTab.isOpenInNewTab}
                label={''}
                onClick={() => onTabChange({ ...currentTab, isOpenInNewTab: !currentTab.isOpenInNewTab })}
                isTeamEdit
            />
          </ProjectEditPageGridInput>
        </ProjectEditPageGridRow>
      </ProjectEditPageGrid>


      <TeamFilterEditView
        filter={currentTab.filter}
        onChange={(filter: ITeamFilterModel) => onTabChange({ ...currentTab, filter: filter })}
        isAdditional={true}
      />

      {/*</PageViewportLayout>*/}
    </>
  );
};
